const contact = [
	{
		path: '/agency/contact-requests/list',
		name: 'contact-requests-list',
		component: () => import('@/views/agency/contact-requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,messages',
		},
	},
	{
		path: '/agency/requests/list',
		name: 'requests-list',
		component: () => import('@/views/agency/requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,messages',
		},
	},
]

export default contact
